const C = {
  name: "NewZealand",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 9C7.55228 9 8 8.55228 8 8C8 7.44772 7.55228 7 7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9Z" fill="currentColor"/>
<path d="M3.98414 10.98C3.36579 10.1479 3 9.11681 3 8C3 5.23772 5.23772 3 8 3C10.4776 3 12.5331 4.8002 12.9306 7.16447C13.4367 7.05671 13.9617 7 14.5 7C18.6421 7 22 10.3579 22 14.5C22 18.6421 18.6421 22 14.5 22C10.3579 22 7 18.6421 7 14.5C7 13.9617 7.05671 13.4367 7.16447 12.9306C6.6556 12.845 6.17286 12.6827 5.72858 12.4558L4.7844 17.1767L2.82324 16.7845L3.98414 10.98ZM5 8C5 9.61301 6.27086 10.9274 7.86659 10.9971C8.57131 9.66534 9.66534 8.57131 10.9971 7.86659C10.9274 6.27086 9.61301 5 8 5C6.34228 5 5 6.34228 5 8ZM9 14.5C9 17.5376 11.4624 20 14.5 20C17.5376 20 20 17.5376 20 14.5C20 11.4624 17.5376 9 14.5 9C11.4624 9 9 11.4624 9 14.5Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as NewZealand
};
